<template>
<transition name="modal">
<div id="modal" class="modal">
  <div class="modal__wrap">
    <div class="modal__wrap__card">
      <header v-if="modalObject.title !== ''" class="modal__wrap__card__header">{{ modalObject.title }}</header>
      <div v-if="modalObject.content !== ''" class="modal__wrap__card__content">{{ modalObject.content }}</div>
      <div class="modal__wrap__card__navi">
        <div v-if="modalObject.showNo" class="modal__wrap__card__navi__btn" @click="$emit('close')">No</div>
        <div v-if="modalObject.showOk" class="modal__wrap__card__navi__btn" @click="$emit('close')">OK</div>
        <router-link v-if="modalObject.routerLink !== ''" :to="modalObject.routerLink" class="modal__wrap__card__navi__btn">Yes</router-link>
        <div v-if="modalObject.href !== ''" @click="gotoLocation" class="modal__wrap__card__navi__btn">Yes</div>
      </div>
      <div class="modal__wrap__card__close" @click="$emit('close')">
        <img src="@/assets/images/custom/custom-close.svg" alt="Close" />
      </div>
    </div>
  </div>
  <div class="modal__background"></div>
</div>
</transition>
</template>

<script>
export default {
  props: { modalObject: Object },
  methods: {
    gotoLocation () {
      location.href = this.modalObject.href
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Modal.vue